import { createContext, useContext } from 'react'

/**
 * Context used to bubble speakable math text from deeply-nested MathMLComponent
 * instances up to a shallow ancestor (SimpleChoiceComponent) that can render
 * a role="math" aria-label at the correct DOM depth for screen readers.
 *
 * When onSpeakableText is non-null, MathMLComponent is inside a choice and
 * should omit its own role/aria attributes, deferring to the parent wrapper.
 */
interface MathSpeakableContextValue {
  onSpeakableText: ((text: string) => void) | null
}

export const MathSpeakableContext = createContext<MathSpeakableContextValue>({
  onSpeakableText: null,
})

export const useMathSpeakableContext = () => useContext(MathSpeakableContext)
